import { render } from "./ListaProdutos.vue?vue&type=template&id=0ede75a6"
import script from "./ListaProdutos.vue?vue&type=script&lang=js"
export * from "./ListaProdutos.vue?vue&type=script&lang=js"
script.render = render

export default script